import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the MebelvisalonPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-mebelvisalon',
  templateUrl: 'mebelvisalon.html',
})
export class MebelvisalonPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MebelvisalonPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/mebelvisalon/mebelvisalon.ts